import { render, staticRenderFns } from "./ModalRuleCheckViolations.vue?vue&type=template&id=0678dd90&scoped=true&"
import script from "./ModalRuleCheckViolations.vue?vue&type=script&lang=ts&"
export * from "./ModalRuleCheckViolations.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRuleCheckViolations.vue?vue&type=style&index=0&id=0678dd90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0678dd90",
  null
  
)

export default component.exports